(() => {
  const ALLOWED = new Set(['all', 'mix', 'shampoo', 'oil', 'herbs', 'tea', 'other']);

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const categoryFromSearch = (searchParams) => {
    let value = normalize(searchParams.get('category'));
    if (value === 'herb') value = 'herbs';
    if (!value || value === 'all' || !ALLOWED.has(value)) return 'all';
    return value;
  };

  const categoryFromLocation = () => categoryFromSearch(new URL(window.location.href).searchParams);

  class LicohennaCollection extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('[data-collection-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-category]'));
      this.empty = this.querySelector('[data-collection-empty]');
      this.onClick = this.onClick.bind(this);
      this.onPopState = this.onPopState.bind(this);

      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPopState);
      this.apply(categoryFromLocation());
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onPopState);
    }

    onClick(event) {
      const link = event.target.closest('[data-collection-filter]');
      if (!link || !this.contains(link)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

      event.preventDefault();
      const url = new URL(link.href, window.location.origin);
      const currentView = new URL(window.location.href).searchParams.get('view');
      if (currentView && !url.searchParams.get('view')) {
        url.searchParams.set('view', currentView);
      }
      const next = categoryFromSearch(url.searchParams);
      const nextHref = `${url.pathname}${url.search}`;
      const currentHref = `${window.location.pathname}${window.location.search}`;

      if (nextHref !== currentHref) {
        window.history.pushState({ category: next }, '', nextHref);
      }

      this.apply(next);
    }

    onPopState() {
      this.apply(categoryFromLocation());
    }

    apply(category) {
      const limit = Number(this.getAttribute('data-visible-limit')) || 0;
      let matched = 0;
      let visible = 0;

      this.cards.forEach((card) => {
        const match = category === 'all' || normalize(card.getAttribute('data-category')) === category;
        if (match) {
          matched += 1;
          const overLimit = limit > 0 && visible >= limit;
          card.hidden = overLimit;
          if (!overLimit) visible += 1;
        } else {
          card.hidden = true;
        }
      });

      if (this.empty) this.empty.hidden = visible > 0;

      this.links.forEach((link) => {
        const linkCategory = normalize(link.getAttribute('data-collection-filter')) || 'all';
        if (linkCategory === category) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('licohenna-collection')) {
    customElements.define('licohenna-collection', LicohennaCollection);
  }
})();
